(function () {
  if (window.CustomerMedia) return;
  const script = document.currentScript;
  let loading;
  let checking;
  const handoff = () => {
    try {
      const record = JSON.parse(sessionStorage.getItem('ccm-media-handoff-v1'));
      return record?.asset?.asset_id && Date.now() - record.savedAt < 7200000 ? record : null;
    } catch (_) { return null; }
  };
  function load() {
    if (!loading) loading = new Promise((resolve, reject) => {
      const css = document.createElement('link');
      css.rel = 'stylesheet'; css.href = script.dataset.mediaCss;
      document.head.append(css);
      const bundle = document.createElement('script');
      bundle.src = script.dataset.mediaJs;
      bundle.onload = () => resolve(window.CustomerMedia);
      bundle.onerror = () => { loading = null; reject(new Error('Photo picker could not load. Please retry.')); };
      document.head.append(bundle);
    });
    return loading;
  }
  window.CustomerMedia = {
    handoff,
    clearHandoff: () => sessionStorage.removeItem('ccm-media-handoff-v1'),
    adopt: async (url, signal) => (await load()).adopt(url, signal),
    verify: async asset => (await load()).verify(asset),
    associate: async (asset, cartToken, signal) => (await load()).associate(asset, cartToken, signal),
    async enabled() {
      if (!checking) checking = (async () => {
        const headers = { Accept: 'application/json' };
        const internal = sessionStorage.getItem('ccm-media-internal');
        if (internal) headers['X-Media-Internal'] = internal;
        const response = await fetch('/apps/crystal-settings/api/media/config', {
          credentials: 'same-origin', cache: 'no-store', headers, signal: AbortSignal.timeout(15000),
        });
        // A backend not deployed yet keeps the existing uploader intact.
        if (response.status === 404) return false;
        if (!response.ok) throw new Error('Photo picker could not load. Please retry.');
        const enabled = (await response.json()).enabled === true;
        if (enabled) await load();
        return enabled;
      })().catch(error => { checking = null; throw error; });
      return checking;
    },
  };
})();
